// extracted by mini-css-extract-plugin
export default {"tupacGrid":"_i-z","tupacHeader":"aj-z","tupacHeader2":"bj-z","tupacMenu":"cj-z","tupacMenu2":"dj-z","tupacMain":"ej-z","tupacMain2":"fj-z"};